import AUTH_API from '@services/auth.service';
import convertToFormData from '@utils/helpers/convertToFormData';
import {
  ICheckNewAIComment,
  ICheckNewAICommentResponse,
} from '@models/interfaces/student.interface';

const AICommentServices = {
  async checkNewAIComment(formData: ICheckNewAIComment) {
    return await AUTH_API.post<ICheckNewAICommentResponse>(
      `ai_comment/get_new_comment/json`,
      convertToFormData(formData),
    );
  },
};

export default AICommentServices;
